export enum OTEventName {
  SHARE_VARIANT = 'signal:SHARE-VARIANT',
  ACTION = 'signal:ACTION',
  TEXT = 'signal:TEXT',
  SHARE = 'signal:SHARE',
  SHARE_VIDEO_AGENT = 'signal:SHARE_VIDEO_AGENT',
  CALL_FORWARD = 'signal:CALL_FORWARD'
}
